import React from 'react';
import { useTranslation } from 'react-i18next';
import LegalPage from '../components/LegalPage';
import { legalConfig } from '../config/legal';
import { renderListItems } from '../utils/legalI18n';

const PrivacyPolicy = () => {
  const { t } = useTranslation('legal');
  const entity = { entityName: legalConfig.entityName, email: legalConfig.contactEmail };

  return (
    <LegalPage title={t('privacyTitle')}>
      <p>{t('privacyIntro', entity)}</p>

      <h2>{t('privacyDataController')}</h2>
      <p>
        {legalConfig.entityName}
        {legalConfig.address && (
          <>
            <br />
            {legalConfig.address}
          </>
        )}
        <br />
        {t('emailLabel')}: <a href={`mailto:${legalConfig.contactEmail}`}>{legalConfig.contactEmail}</a>
      </p>

      <h2>{t('privacyDataCollected')}</h2>
      <ul>
        {renderListItems('privacyDataCollectedList', t).map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>

      <h2>{t('privacyHowWeUse')}</h2>
      <ul>
        {renderListItems('privacyHowWeUseList', t).map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>

      <h2>{t('privacyLegalBasis')}</h2>
      <ul>
        {renderListItems('privacyLegalBasisList', t).map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>

      <h2>{t('privacyRetention')}</h2>
      <p>{t('privacyRetentionBody')}</p>

      <h2>{t('privacyRights')}</h2>
      <p>{t('privacyRightsBody', entity)}</p>

      <h2>{t('privacyContact')}</h2>
      <p>
        {t('privacyContactBody')}{' '}
        <a href={`mailto:${legalConfig.contactEmail}`}>{legalConfig.contactEmail}</a>
      </p>
    </LegalPage>
  );
};

export default PrivacyPolicy;
